export const NEWS_ADMIN_CHANGE_TAB = "NEWS_ADMIN_CHANGE_TAB";
export const newsAdminChangeTab = (tab) => {
  return {
    type: NEWS_ADMIN_CHANGE_TAB,
    payload: tab,
  };
};
